// Single source for each filter's values: the pill label and the drawer's
// dropdown both read from these, so they can never drift apart.
export const EXCHANGE_OPTIONS = [
  { value: 'NSE', label: 'Cash NSE' },
  { value: 'BSE', label: 'Cash BSE' },
  { value: 'NFO', label: 'Derivative NFO' },
  { value: 'BFO', label: 'Derivative BFO' },
  { value: 'MCX', label: 'Commodities' },
  { value: 'CDS', label: 'Forex' },
  { value: 'DCSX', label: 'Crypto' },
];

export const BUY_SELL_OPTIONS = [
  { value: '2', label: 'All' },
  { value: '0', label: 'Buy' },
  { value: '1', label: 'Sell' },
];

export const ERROR_TRADE_OPTIONS = [
  { value: false, label: 'No' },
  { value: true, label: 'Yes' },
];

const labelOf = (options, value) => options.find((opt) => opt.value === value)?.label ?? String(value);

// Module-level so the hook receives a stable reference across renders.
export const TRADE_FILTER_DEFS = [
  {
    key: 'exchange',
    label: 'Exchange',
    // The first exchange (Cash NSE): the leftmost tab is the one selected on load.
    default: EXCHANGE_OPTIONS[0].value,
    displayFn: (val) => labelOf(EXCHANGE_OPTIONS, val),
  },
  {
    key: 'buySell',
    label: 'Buy/Sell',
    default: '2',
    hideLabel: true,
    // '2' means "no filter", so the pill names the filter instead of the value.
    displayFn: (val) => (val === '2' ? 'Buy/Sell' : labelOf(BUY_SELL_OPTIONS, val)),
  },
  {
    key: 'isErrorTrade',
    label: 'Error Trade',
    default: false,
    displayFn: (val) => labelOf(ERROR_TRADE_OPTIONS, val),
  },
];
